module.exports = __webpack_public_path__ + "img/box-skins-violet.4fa740e3.jpg";